import { EBonusType } from './../../Bonuses/BonusOnDeposit/types';
// Notice: temporary solution there is no description for all cards yet
export const IGNORED_BONUS_TYPES = [
  EBonusType.Monthly,
  EBonusType.Support,
  EBonusType.RakeBackBoost,
  EBonusType.Weekly,
  EBonusType.Retention,
];
